<template>
  <DBox :id="'cmp-royalty-contracts-sidewindow-contract_products'" 
    :addButton="false" 
    :addLink="false"
    :addLinkLabel="$dft.snakeCaseToWords($t('add_new_product'))"
     @add_click="onAddProducts" 
     @menuClick="onRightMenuClick"
    :searchButton="true"
    :searchFlag="searchFlag"
    :leftMenu="[
      {
      text: this.$dft.snakeCaseToWords($t('+ add_new_product')),
      value: 'add_new_product', 
    },
    {
      text: this.$dft.snakeCaseToWords($t('- remove_all_products')),
      value: 'remove_all_products', buttonStyle:1
    }
  ]"
     :badgeButtons="filterExists
      ? [
        {
          text: 'Reset Filters',
          value: 'reset_filters',
          icon: 'delete-white'
        }
      ]
      : []
      " @searchClick="onSearchClick" @badgeClick="onBadgeClick">
    <div v-if="searchFlag" class="ut-flex ut-jbetween">
      <div class="search-controls ut-flex">
        <InputField :value="searchString" :placeholder="'Search'" :config="{
          borderStyle: 'bottom',
          width: '124px'
        }" @keyup="onSearchInputKeyup"></InputField>
      </div>
    </div>
    <div class="ut-fh" :style="{
      height: this.searchFlag ? `calc(100% - 52px)` : undefined,
    }">
      <NTable class="dbox1" id="royalty-contracts-sidewindow-contract_products-list" :config="tableConfig"
        :headers="headers" :items="selectedContractDetails.products || []" :showNoItems="false">
        <template v-slot:item="{ item, tdcon }">
          <template v-if="mechanical_flag">
            <tr>
            <td v-bind="tdcon('barcode')">
              <span @click.stop="(e) => onSelectProducts(item)" class="txtov ut-link ut-text-accent5"
                :title="item['barcode']">
                {{ item["barcode"] }}
              </span>
            </td>
            <td v-bind="tdcon('catalog_no')">
              <span @click.stop="(e) => onSelectProducts(item)" class="txtov ut-link ut-text-accent5"
                :title="item['catalog_no']">
                {{ item["catalog_no"] }}
              </span>
            </td>
     
            <td v-bind="tdcon('format')">
              <span>{{ item["format"] }}</span>
            </td>
            <td v-bind="tdcon('settings')">
              <span>{{ item["rule"] }}</span>
            </td>
            <td v-bind="tdcon('rata')">
              <span>{{ item["rata"] }}</span>
            </td>
            <td v-bind="tdcon('share')">
              <TextField2 :ta="'right'" :id="'share'" :type="'percent'" :showLabel="false" :value="item['share']"
                @blur="(e) => onTextFieldValueChange(e, item)" :bb="'none'" />
            </td>

            <td v-bind="tdcon('exclude')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input type="checkbox" :name="`exclude-${item['exclude']}`" :id="`exclude-${item['contract_pos_id']}`"
                    :checked="item['exclude'] == '1'" @click="(e) => onContractExclude(e, item)" />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            
            <td v-bind="tdcon('options')">
             <div style="display: flex;justify-content: center;align-items: center;">
              <img
                        @click.stop="(e) => onStatementEditClick(item)"
                        src="static/icons/edit.svg"
                        class="dt-icon v5 s1"
                        alt="edit"
                        title="edit"
                      />
              <img src="static/icons/delete.svg" @click.stop="(e) => onDeleteProducts(item)"
                class="dt-icon v5 s1 ut-center" alt />
             </div>
            </td>
          </tr>
          </template>
          <template v-else>
            <tr>
            <td v-bind="tdcon('products')">
              <span @click.stop="(e) => onSelectProducts(item)" class="txtov ut-link ut-text-accent5"
                :title="item['barcode']">
                {{ item["barcode"] }}
              </span>
            </td>
            <td v-bind="tdcon('catalog_no')">
              <span @click.stop="(e) => onSelectProducts(item)" class="txtov ut-link ut-text-accent5"
                :title="item['catalog_no']">
                {{ item["catalog_no"] }}
              </span>
            </td>
            <td v-bind="tdcon('artist_title')">
              <span @click.stop="(e) => onSelectProducts(item)" class="txtov ut-link ut-text-accent5"
                :title="item['artist'] + ' / ' + item['title']">
                {{ item['alt_artist'] ? item['alt_artist'] : item["artist"] }} / {{
                  item['alt_title'] ? item['alt_title'] : item["title"] }}
              </span>
            </td>
            <td v-bind="tdcon('format')">
              <span>{{ item["format_name"] }}</span>
            </td>

            <td v-bind="tdcon('rata1_rata2')">
              <div class="ut-flex rata-block">
                <TextField2 :ta="'right'" :id="'rata1'" :type="'number'" :showLabel="false" :value="item['rata1']"
                  @blur="(e) => onTextFieldValueChange(e, item)" :bb="'none'" />
                <span class="divider-line ut-flex">/</span>
                <TextField2 :ta="'right'" :id="'rata2'" :type="'number'" :showLabel="false" :value="item['rata2']"
                  @blur="(e) => onTextFieldValueChange(e, item)" :bb="'none'" />
                <span class="is-royalty-verify">
                  <b v-if="RoyaltyVerify(item)"
                    title="This item will not create any royalties, because the Rata or Share is 0/blank."
                    class="ut-text-accent" style="margin-left: 3px">!!!</b>
                </span>
              </div>
            </td>
            <!-- <td v-bind="tdcon('upc')">
            <TextField2
              :id="'upc'"
              :showLabel="false"
              :value="item['barcode']"
              @blur="e => onTextFieldValueChange(e, item)"
              :bb="'none'"
            />
          </td> -->
            <td v-bind="tdcon('share')">
              <TextField2 :ta="'right'" :id="'share'" :type="'percent'" :showLabel="false" :value="item['share']"
                @blur="(e) => onTextFieldValueChange(e, item)" :bb="'none'" />
            </td>

            <td v-bind="tdcon('exclude')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input type="checkbox" :name="`exclude-${item['exclude']}`" :id="`exclude-${item['contract_pos_id']}`"
                    :checked="item['exclude'] == '1'" @click="(e) => onContractExclude(e, item)" />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('recoupable')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input type="checkbox" :name="`cost_split-${item['allow_cost_split_flag']}`"
                    :id="`cost_split-${item['contract_pos_id']}`" :checked="item['allow_cost_split_flag'] == '1'"
                    @click="(e) => onCheckboxChange(e, item)" />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <img src="static/icons/delete.svg" @click.stop="(e) => onDeleteProducts(item)"
                class="dt-icon v5 s1 ut-center" alt />
            </td>
          </tr>
          </template>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { EventHooks } from "../../../../plugins/text-field";
import {
  productsListLDTRoutes,
  tracksListLDTRoutes,
} from "../../../catalog/router/routes";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
export default {
  components: {
    DBox,
    NTable,
  },
  props: ["channel", "selectedContractDetails"],
  data: function () {
    return {
      searchFlag: false,
      searchString: "",
      searchSubject$: new Subject(),
      scrollSubject: new Subject(),
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
      textFieldConfig: {
        height: 27,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
    }
  },
  mounted() {
    this.$subscribeTo(
      this.searchSubject$
        .asObservable()
        .pipe(debounceTime(500), distinctUntilChanged()),
      (searchString) => {
        this.searchString = searchString;
        this.$emit('emitSearchString', { searchString: searchString, action: 'products' });
      }
    );
  },
  computed: {
    filterExists() {
      return this.searchString != "";
    },
    mechanical_flag:function(){
     return this.selectedContractDetails?.contract?.mechanical_flag;
    },
    headers: function () {
      return this.mechanical_flag?[
        createTableHeader("barcode", { mw: 120 }),
        createTableHeader("catalog_no", { mw: 120 }),
       
        createTableHeader("format",{mw:150}),
        createTableHeader("settings"),
        createTableHeader("rata", {
          mw: 115,
          ta: "center",
        }),
        createTableHeader("share", {
          mw: 80,
          minw: 80,
          ta: "right",
          text: `${this.$t("cost_share")}`,
        }),
        createTableHeader("exclude", { mw: 70, minw: 70, ta: "center" }),
        createTableHeader("options", { text: false, mw: 80 }),
      ]:[
        createTableHeader("products", { mw: 120 }),
        createTableHeader("catalog_no", { mw: 120 }),
        createTableHeader("artist_title", {
          f: 1.75,
          text: `${this.$t("artist")}/${this.$t("title")}`,
        }),
        // createTableHeader("ds_title"),
        createTableHeader("format"),
        createTableHeader("rata1_rata2", {
          mw: 115,
          ta: "center",
        }),
        createTableHeader("share", {
          mw: 80,
          minw: 80,
          ta: "right",
          text: `${this.$t("share")}`,
        }),
        createTableHeader("exclude", { mw: 70, minw: 70, ta: "center" }),
        createTableHeader("recoupable", { mw: 80, minw: 80, ta: "center" }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];;
    },
  },
  methods: {
    onStatementEditClick(item){
      this.$emit('edit', item);
    },
    onSearchClick: function () {
      this.searchFlag = !this.searchFlag;
      this.$emit('showSearchFlag', this.searchFlag);
    },
    onSearchInputKeyup: function (event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(event.target.value);
    },
    onBadgeClick(badge) {
      if (badge == "reset_filters") {
        this.searchString = "";
        this.searchFlag = false;
        this.$emit('emitSearchString', { searchString: this.searchString, action: 'products' });
        this.$emit('showSearchFlag', this.searchFlag);
      }
    },
    onSelectProducts: function (selectedProducts) {
      this.$emit("selected", selectedProducts.product_id);
    },
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", { name, value, item });
    },

    onContractExclude: function (e, item) {
      if (e.target.checked) {
        this.$emit("changed", {
          name: "exclude",
          value: 1,
          item,
          contract_id: this.selectedContractDetails.products.contract_id,
        });
      } else {
        this.$emit("changed", {
          name: "exclude",
          value: 0,
          item,
          contract_id: this.selectedContractDetails.products.contract_id,
        });
      }
    },
    onCheckboxChange: function (e, item) {
      if (e.target.checked) {
        this.$emit("changed", {
          name: "allow_cost_split_flag",
          value: 1,
          item,
          contract_id: this.selectedContractDetails.products.contract_id,
        });
      } else {
        this.$emit("changed", {
          name: "allow_cost_split_flag",
          value: 0,
          item,
          contract_id: this.selectedContractDetails.products.contract_id,
        });
      }
    },

    onAddProducts: function () {
      this.$emit("add_click", true);
    },
    onRightMenuClick: async function (menu) {
      if(menu=='add_new_product'){
         this.onAddProducts();
      }
      else{
        this.$emit("deletedAll", { channel: this.channel });
      }
     
      
    },
    onDeleteProducts: function (item) {
      // const confirmationResult = await confirmDelete(
      //   "Product",
      //   item.product_barcode
      // );
      // if (confirmationResult === "OK") {
      //   this.$emit("deleted", { ...item, channel: this.channel });
      // }
      this.$emit("deleted", { ...item, channel: this.channel });
    },

    RoyaltyVerify(item) {
      // console.log("rata1/rata2 ", item);
      const { share_rata, rata1, rata2 } = item;
      if (!share_rata) {
        return true;
      }
      if (share_rata && !rata1 && rata2) {
        return true;
      }
      // const { main_product, main_product_track, other_product_track } = item;
      // if (!main_product) {
      //   return true;
      // } else if (main_product && !main_product_track && other_product_track) {
      //   return true;
      // }
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-contract_products {
  .search-controls {
    .input-field-container {
      margin: 10px;
    }
  }

  .royalty-contracts-sidewindow-contract_products-list {

    .rata-block {
      justify-content: flex-end;
      padding-right: 4px;
      margin: 0 !important;

      .fc2-textfield {
        flex: 1;
        width: 100%;
        max-width: 35px;

        .fc-control {
          padding-right: 2px !important;
          padding-left: 2px !important;
        }
      }
    }

    .divider-line {
      width: 10px;
      justify-content: center;
      color: var(--text-5);
    }

    .is-royalty-verify {
      width: 14px;
    }
  }
}
</style>
